import React from "react";
import Select from "react-select";

export const CustomSelect = ({
  className,
  placeholder,
  field,
  name,
  form,
  options,
  isMulti = false,
}) => {
  const onChange = (option) => {
    form.setFieldValue(
      field?.name || name,
      isMulti ? option?.map((item) => item?.value) : option?.value
    );
  };

  const getValue = () => {
    if (options) {
      return isMulti
        ? options?.filter((option) => field?.value.indexOf(option?.value) >= 0)
        : options?.find((option) => option?.value === field?.value);
    } else {
      return isMulti ? [] : "";
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "none", // Remove the border
      boxShadow: "none", // Remove the box shadow

      paddding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      minHeight: "30px", // Adjust the minimum height of each option as needed
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      display: "none", // Hide the indicator separator
    }),
  };

  return (
    <Select
      styles={customStyles}
      className={className}
      name={field?.name || name}
      value={getValue()}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      isMulti={isMulti}
    />
  );
};

export default CustomSelect;
